<tui-action-bar
    *tuiActionBar="true"
    [expanded]="!!isMobile"
    [ngClass]="[isMobile ? 'mobile-banner' : 'desktop-banner', isOpen ? 'changes-banner' : '']"
>
    @if (isOpen) {
        <div tuiTitle>
            {{ bannerMessage }}
        </div>
    } @else if (!isOpen && isMobile) {
        <div tuiTitle>PUBLISH</div>
    }
    @if (isOpen) {
        <button
            appearance="secondary"
            iconStart="@tui.trash"
            size="m"
            tuiButton
            type="button"
            (click)="discardClicked($event)"
            id="banner-discard-button"
        >
            {{ isMobile ? '' : discardText }}
        </button>
    }
    <button
        appearance="primary"
        iconStart="@tui.send"
        size="m"
        tuiButton
        type="button"
        (click)="confirmClicked($event)"
    >
        {{ isMobile ? '' : confirmText }}
    </button>

    @if (displayCloseButton) {
        <button appearance="icon" iconStart="@tui.x" size="m" tuiIconButton type="button" (click)="closeBanner()">
            Close
        </button>
    }
</tui-action-bar>
